import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';
import { LoaderService } from 'src/app/shared/services/loader/loader.service';

@Injectable()
export class LoaderInterceptor implements HttpInterceptor {
  constructor(private loader: LoaderService) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    // Ignora assets estáticos
    const ignore = req.url.includes('/assets/') || req.headers.has('x-ignore-loader');
    if (!ignore) this.loader.start();
    return next.handle(req).pipe(finalize(() => { if (!ignore) this.loader.stop(); }));
  }
}

